export enum UrlParamsKeys {
  JoinCartId = 'join_cart_id',
  ShareCode = 'share_code',
  CatalogIds = 'catalogId',
  /** CB2 Studio preview mode (webapp embedded in the dashboard iframe). */
  CbPreview = 'cbPreview',
  /** CB2 compiled spec. `draft` loads unpublished content; anything else is live. */
  CbMode = 'cb_mode',
  /** Only render the inline page body in the iframe (no shell/footer/redirects). */
  CbInlineOnly = 'cbInlineOnly',
}
